export const AUTH_START = 'AUTH_START';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const ADMIN_USER_LOGIN_SUCCESS = 'ADMIN_USER_LOGIN_SUCCESS';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

export const CUSTOMERS_FETCH_SUCCESS = 'CUSTOMERS_FETCH_SUCCESS';
export const SET_CUSTOMERS_DRAFT = 'SET_CUSTOMERS_DRAFT';
export const DOWNLOAD_CUSTOMERS_SUCCESS = 'DOWNLOAD_CUSTOMERS_SUCCESS';
export const CUSTOMER_FETCH_SUCCESS = 'CUSTOMER_FETCH_SUCCESS';
export const CUSTOMER_SET_DRAFT = 'CUSTOMER_SET_DRAFT';
export const REMOVE_ITEM_FROM_CUSTOMER_DRAFT = 'REMOVE_ITEM_FROM_CUSTOMER_DRAFT';
export const CUSTOMER_PROFILE_FETCH_SUCCESS = 'CUSTOMER_PROFILE_FETCH_SUCCESS';
export const CUSTOMER_PROFILE_SET_DRAFT = 'CUSTOMER_PROFILE_SET_DRAFT';
export const CUSTOMER_PROFILE_UPDATE_SUCCESS = 'CUSTOMER_PROFILE_UPDATE_SUCCESS';
export const CUSTOMER_PROFILE_UPDATE_DRAFT = 'CUSTOMER_PROFILE_UPDATE_DRAFT';
export const CUSTOMER_LOADING = 'CUSTOMER_LOADING';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';

export const FETCH_ACTIVE_PROVIDERS = 'FETCH_PROVIDERS';
export const FETCH_ACTIVE_PROVIDERS_SUCCESS = 'FETCH_PROVIDERS_SUCCESS';
export const FETCH_ACTIVE_PROVIDERS_FAILURE = 'FETCH_PROVIDERS_FAILURE';

export const FETCH_ALL_PROVIDERS = 'FETCH_ALL_PROVIDERS';
export const FETCH_ALL_PROVIDERS_SUCCESS = 'FETCH_ALL_PROVIDERS_SUCCESS';
export const FETCH_ALL_PROVIDERS_FAILURE = 'FETCH_ALL_PROVIDERS_FAILURE';

export const TOGGLE_PROVIDER_ACTIVATION = 'TOGGLE_PROVIDER_ACTIVATION';
export const TOGGLE_PROVIDER_ACTIVATION_SUCCESS = 'TOGGLE_PROVIDER_ACTIVATION_SUCCESS';
export const TOGGLE_PROVIDER_ACTIVATION_FAILURE = 'TOGGLE_PROVIDER_ACTIVATION_FAILURE';

export const FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS = 'FETCH_ALL_MYCOINS_TRANSACTIONS_SUCCESS';
export const DOWNLOAD_MYCOINS_TRANSACTIONS = 'DOWNLOAD_MYCOINS_TRANSACTIONS';

export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const CREATE_USERS_SUCCESS = 'CREATE_USERS_SUCCESS';
export const DELETE_USERS_SUCCESS = 'DELETE_USERS_SUCCESS';
export const GENERATE_USERS_PASSWORD_SUCCESS = 'GENERATE_USERS_PASSWORD_SUCCESS';

export const CUSTOM_TYPE_FETCH_SUCCESS = 'CUSTOM_TYPE_FETCH_SUCCESS';
export const CUSTOM_TYPE_FETCH_FAIL = 'CUSTOM_TYPE_FETCH_FAIL';
export const CUSTOM_TYPE_FETCH_BY_ID_SUCCESS = 'CUSTOM_TYPE_FETCH_BY_ID_SUCCESS';
export const CUSTOM_TYPE_FETCH_BY_ID_FAIL = 'CUSTOM_TYPE_FETCH_BY_ID_FAIL';
export const CUSTOM_TYPE_CREATE_SUCCESS = 'CUSTOM_TYPE_CREATE_SUCCESS';
export const CUSTOM_TYPE_SET_DRAFT = 'CUSTOM_TYPE_SET_DRAFT';
export const CUSTOM_TYPE_DELETE = 'CUSTOM_TYPE_DELETE';
export const CUSTOM_TYPE_UPDATE_SUCCESS = 'CUSTOM_TYPE_UPDATE_SUCCESS';

export const CONTENT_FETCH_SUCCESS = 'CONTENT_FETCH_SUCCESS';
export const CONTENT_FETCH_FAIL = 'CONTENT_FETCH_FAIL';
export const CONTENT_FETCH_BY_ID_SUCCESS = 'CONTENT_FETCH_BY_ID_SUCCESS';
export const CONTENT_FETCH_BY_ID_FAIL = 'CONTENT_FETCH_BY_ID_FAIL';
export const CONTENT_SET_DRAFT = 'CONTENT_SET_DRAFT';

export const CONTENT_REVIEW_FETCH_SUCCESS = 'CONTENT_REVIEW_FETCH_SUCCESS';
export const CONTENT_REVIEW_FETCH_FAIL = 'CONTENT_REVIEW_FETCH_FAIL';
export const CONTENT_REVIEW_FETCH_BY_ID_SUCCESS = 'CONTENT_REVIEW_FETCH_BY_ID_SUCCESS';
export const CONTENT_REVIEW_FETCH_BY_ID_FAIL = 'CONTENT_REVIEW_FETCH_BY_ID_FAIL';
export const CONTENT_REVIEW_SET_DRAFT = 'CONTENT_REVIEW_SET_DRAFT';

export const FILES_FETCH_SUCCESS = 'FILES_FETCH_SUCCESS';
export const FILES_FETCH_FAIL = 'FILES_FETCH_FAIL';
export const IMAGE_FETCH_SUCCESS = 'IMAGE_FETCH_SUCCESS';
export const IMAGE_FETCH_FAIL = 'IMAGE_FETCH_FAIL';

export const PROJECT_FETCH_SUCCESS = 'PROJECT_FETCH_SUCCESS';
export const PROJECT_FETCH_FAIL = 'PROJECT_FETCH_FAIL';
export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const PROJECT_CREATE_SUCCESS = 'PROJECT_CREATE_SUCCESS';
export const PROJECT_DELETE_SUCCESS = 'PROJECT_DELETE_SUCCESS';
export const PROJECT_UPDATE_SUCCESS = 'PROJECT_UPDATE_SUCCESS';

export const LANGUAGE_FETCH_SUCCESS = 'LANGUAGE_FETCH_SUCCESS';
export const ACTIVE_LANGUAGE_FETCH_SUCCESS = 'ACTIVE_LANGUAGE_FETCH_SUCCESS';
export const LANGUAGE_FETCH_FAIL = 'LANGUAGE_FETCH_FAIL';
export const LANGUAGE_UPDATE_SUCCESS = 'LANGUAGE_UPDATE_SUCCESS';
export const LANGUAGE_UPDATE_FAIL = 'LANGUAGE_UPDATE_FAIL';

export const TRANSLATE_TEXT_SUCCESS = 'TRANSLATE_TEXT_SUCCESS';

export const TOGGLE_CART_DRAWER = 'TOGGLE_CART_DRAWER';
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const UPDATE_ITEM_IN_CART = 'UPDATE_ITEM_IN_CART';
export const CLEAR_CART = 'CLEAR_CART';

export const DOMAIN_FETCH_SUCCESS = 'DOMAIN_FETCH_SUCCESS';
export const DOMAIN_FETCH_FAIL = 'DOMAIN_FETCH_FAIL';
export const DOMAIN_FETCH_BY_NAME_SUCCESS = 'DOMAIN_FETCH_BY_NAME_SUCCESS';
export const DOMAIN_FETCH_BY_NAME_FAIL = 'DOMAIN_FETCH_BY_NAME_FAIL';
export const DOMAIN_TRANSFER_FETCH_SUCCESS = 'DOMAIN_TRANSFER_FETCH_SUCCESS';
export const DOMAIN_TRANSFER_FETCH_FAIL = 'DOMAIN_TRANSFER_FETCH_FAIL';
export const DOMAIN_EXPIRED_FETCH_SUCCESS = 'DOMAIN_EXPIRED_FETCH_SUCCESS';
export const DOMAIN_EXPIRED_FETCH_FAIL = 'DOMAIN_EXPIRED_FETCH_FAIL';

export const ITEMS_FETCH_SUCCESS = 'ITEMS_FETCH_SUCCESS';
export const CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS';
export const DOWNLOAD_ITEMS = 'DOWNLOAD_ITEMS';
export const GET_ITEM_SUCCESS = 'GET_ITEM_SUCCESS';
export const ITEM_LOADING = 'ITEM_LOADING';
export const SET_ITEM_DRAFT = 'SET_ITEM_DRAFT';
export const SET_ITEM_ADDRESS_DRAFT = 'SET_ITEM_ADDRESS_DRAFT';
export const SET_ITEM_OPTIONS_DRAFT = 'SET_ITEM_OPTIONS_DRAFT';
export const SET_ITEM_IMAGES_DRAFT = 'SET_ITEM_IMAGES_DRAFT';

export const ITEMS_DELETE_SUCCESS = 'ITEMS_DELETE_SUCCESS';
export const PUSH_NOTIFICATIONS_FETCH_SUCCESS = 'PUSH_NOTIFICATIONS_FETCH_SUCCESS';
export const PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS = 'PUSH_NOTIFICATIONS_TOPICS_FETCH_SUCCESS';

export const PUSH_NOTIFICATIONS_CREATE_SUCCESS = 'PUSH_NOTIFICATIONS_CREATE_SUCCESS';

export const ORDERS_FETCH_SUCCESS = 'ORDERS_FETCH_SUCCESS';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const ORDER_LOADING = 'ORDER_LOADING';
export const SET_ORDER_STATUS_DRAFT = 'SET_ORDER_STATUS_DRAFT';
export const DOWNLOAD_ORDERS_SUCCESS = 'DOWNLOAD_ORDERS_SUCCESS';
export const CATEGORIES_FETCH_SUCCESS_ECOMMERCE = 'CATEGORIES_FETCH_SUCCESS_ECOMMERCE';
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CATEGORY_ENABLE_UPDATE_SUCCESS = 'CATEGORY_ENABLE_UPDATE_SUCCESS';
export const SELECTED_CATEGORY = 'SELECTED_CATEGORY';
export const CATEGORY_CREATE_DRAFT = 'CATEGORY_CREATE_DRAFT';
export const CATEGORY_EDIT_DRAFT = 'CATEGORY_EDIT_DRAFT';
export const CATEGORY_FETCH_SUCCESS = 'CATEGORY_FETCH_SUCCESS';
export const CATEGORY_DELETE_SUCCESS = 'CATEGORY_DELETE_SUCCESS';
export const CATEGORY_LOADING = 'CATEGORY_LOADING';

export const FETCH_CLAIMS_SUCCESS = 'FETCH_CLAIMS_SUCCESS';
export const GET_CLAIM_SUCCESS = 'GET_CLAIM_SUCCESS';
export const GET_CLAIM_PDF = 'GET_CLAIM_PDF';
export const CLAIMS_LOADING = 'CLAIMS_LOADING';
export const SET_CLAIM_DRAFT = 'SET_CLAIM_DRAFT';
export const SET_CONNECTING_FLIGHT_DRAFT = 'SET_CONNECTING_FLIGHT_DRAFT';
export const SET_PROBLEMS_DRAFT = 'SET_PROBLEMS_DRAFT';
export const ON_CLAIM_UPDATE_SUCCESS = 'ON_CLAIM_UPDATE_SUCCESS';
export const DOWNLOAD_CLAIM_CSV = 'DOWNLOAD_CLAIM_CSV';

export const ACCOUNT_FETCH_SUCCESS = 'ACCOUNT_FETCH_SUCCESS';
export const ACCOUNT_FETCH_FAIL = 'ACCOUNT_FETCH_FAIL';
export const SET_ACCOUNT = 'SET_ACCOUNT';
export const SET_ACCOUNT_PASSWORD = 'SET_ACCOUNT_PASSWORD';
export const ACCOUNT_UPDATE_SUCCESS = 'ACCOUNT_UPDATE_SUCCESS';
export const ACCOUNT_PASSWORD_UPDATE_SUCCESS = 'ACCOUNT_PASSWORD_UPDATE_SUCCESS';

export const EMAIL_SUBSCRIPTION_FETCH_SUCCESS = 'EMAIL_SUBSCRIPTION_FETCH_SUCCESS';
export const DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS = 'DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS';

export const FETCH_DELIVERIES = ' FETCH_DELIVERIES';
export const UPDATE_DELIVERY = ' UPDATE_DELIVERY';
export const SET_DELIVERY_DRAFT = ' SET_DELIVERY_DRAFT';
export const GET_AIRPORTS = 'GET_AIRPORTS';
export const SET_AIRPORTS = 'SET_AIRPORTS';

export const EMAIL_NOTIFICATION_FETCH_SUCCESS = 'EMAIL_NOTIFICATION_FETCH_SUCCESS';
export const DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS = 'DOWNLOAD_EMAIL_NOTIFICATION_SUCCESS';

export const TEXT_NOTIFICATION_FETCH_SUCCESS = 'TEXT_NOTIFICATION_FETCH_SUCCESS';
export const DOWNLOAD_TEXT_NOTIFICATION_SUCCESS = 'DOWNLOAD_TEXT_NOTIFICATION_SUCCESS';
export const SET_LAWYERS = 'SET_LAWYERS';

export const COMMENTS_FETCH_SUCCESS = 'COMMENTS_FETCH_SUCCESS';

export const COMPLAINS_FETCH_SUCCESS = 'COMPLAINS_FETCH_SUCCESS';

export const IPAY_FETCH_SUCCESS = 'TEXT_IPAY_SUCCESS';
export const DOWNLOAD_IPAY_SUCCESS = 'DOWNLOAD_IPAY_SUCCESS';

export const DOMAINS_FETCH_SUCCESS = 'DOMAINS_FETCH_SUCCESS';
export const EMAIL_ACTIVATION_SUCCESS = 'EMAIL_ACTIVATION_SUCCESS';

export const PAYMENT_SUBSCRIPTION_FETCH_SUCCESS = 'PAYMENT_SUBSCRIPTION_FETCH_SUCCESS';
export const PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS = 'PAYMENT_SUBSCRIPTION_UPDATE_SUCCESS';

export const REVIEWS_FETCH_SUCCESS = 'REVIEWS_FETCH_SUCCESS';

export const PAYZE_PROVIDER_FETCH_SUCCESS = 'PAYZE_PROVIDER_FETCH_SUCCESS';
export const DOWNLOAD_PAYZE_PROVIDER_SUCCESS = 'DOWNLOAD_PAYZE_PROVIDER_SUCCESS';
